import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApplicationTypes } from '../../models/lab-user-menu/application-types';
import { ILab } from '../../models/lab-user-menu/lab';
import { INewApplicationRequest } from '../../models/lab-user-menu/new-application-request';
import { INewApplicationResult } from '../../models/lab-user-menu/new-application-result';
import { environment } from '@env/environment';
import { IApplicationMethodsViewModel, IApplicationReportViewModel, IApplicationTechnologyReport, IApplicationTechnologyViewModel, IFoaReportViewModel } from 'app/models/reports/reports';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class LabApplicationMenuService {
  private api: string = environment.privateApi + 'ApplicationMenu/';
  private reportApi: string = environment.privateApi + 'Reports/';

  constructor(private http: HttpClient) {}

  getLab(labId: number): Observable<ILab> {
    return this.http.get<ILab>(this.api + 'lab/' + labId, httpOptions);
  }

  deleteApplication(labId: number, appId: number): Observable<any> {
    return this.http.delete<any>(this.api + 'deleteApplication/' + labId + '/' + appId, httpOptions);
  }

  getApplicationTypes(orelapId: string): Observable<IApplicationTypes> {
    return this.http.get<IApplicationTypes>(this.api + 'getApplicationTypes/' + orelapId, httpOptions);
  }

  createApplication(application: INewApplicationRequest): Observable<INewApplicationResult> {
    return this.http.post<INewApplicationResult>(this.api + 'createApplication', application, httpOptions);
  }

  getFoaReport(labId: number): Observable<IFoaReportViewModel[]> {
    return this.http.get<IFoaReportViewModel[]>(this.reportApi + 'getFoaReport/' + labId, httpOptions);
  }

  getTechReport(labId: number): Observable<IApplicationTechnologyReport> {
    return this.http.get<IApplicationTechnologyReport>(this.reportApi + 'getTechReport/' + labId, httpOptions);
  }

  getApplicationReport(labId: number, appId: number): Observable<IApplicationReportViewModel> {
    return this.http.get<IApplicationReportViewModel>(this.reportApi + 'getApplicationReport/' + labId + '/' + appId, httpOptions);
  }

}
